module.exports = __webpack_public_path__ + "static/media/adventure.72ee1388.jpg";